import React, { useReducer, createContext, useContext } from "react";
import { layerReducer, layerInitialState } from '../reducers';
import constant from '../constants/layerConstant';
import { layerService } from "../services";
import { toast } from "react-toastify";

export const layerContext = createContext();

export const LayerContextProvider = (props) => {

    const [state, dispatch] = useReducer(layerReducer, layerInitialState);


    const getTree = () => {

        dispatch(request());

        layerService.getTree().then(response => {
            if (!response.success) {

                toast.error(response.message);

                dispatch(fail("!"));

                return;

            }

            dispatch(success(response.data));
        }).catch(ex => {

            toast.error("ağaç getirilemedi!");

            dispatch(fail("!"));
        });
        function request() { return { type: constant.GET_TREE }; }
        function success(data) { return { type: constant.GET_TREE_SUCCESS, payload: data }; }
        function fail(data) { return { type: constant.GET_TREE_FAIL, payload: data } }

    };

    return (
        <layerContext.Provider value={[state,
            {
                getTree,

            }]}>
            {props.children}
        </layerContext.Provider>
    )
};


